import { get } from 'lodash';
import { ForgeButton } from '@tylertech/forge-react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { none } from 'ts-option';

import ExportModal, { TOGGLE_OPTIONS } from 'common/components/ExportModal';
import { getQueryStringFromVif } from 'common/components/ExportModal/ExportHelper';
import { I18n } from 'common/i18n';
import { DisplayType, View } from 'common/types/view';
import { Vif } from 'common/visualizations/vif';
import reducer from '../reducer';

export class InfoPaneButtons extends Component<InfoPaneButtonsProps> {
  state = {
    isExportModalOpen: false,
  };

  showExportModal() {
    this.setState({ isExportModalOpen: true });
  }

  hideExportModal = () => {
    this.setState({ isExportModalOpen: false });
  };

  render() {
    const { parentView, vifs, view } = this.props;
    let response: JSX.Element | null = null;

    if (parentView) {
      const useView = view || parentView;
      const vifType = get(vifs, '[0]series[0].type', undefined) || useView.displayType;
      const exportText = I18n.t('controls.common.sidebar.tabs.export');
      const queryStringClause = vifs?.length ? getQueryStringFromVif(vifs[0]) : '';

      response = (
        <div className="info-pane-buttons">
          <ForgeButton variant="raised" onClick={() => this.showExportModal()} aria-label={exportText}>
            {exportText}
          </ForgeButton>
          {this.state.isExportModalOpen && (
            <ExportModal
              view={parentView}
              query={none}
              queryStringClause={queryStringClause}
              onDismiss={() => this.hideExportModal()}
              fourfour={useView.id}
              bodyText={useView.name}
              isTableViz={[DisplayType.Table, 'agTable'].includes(vifType)}
              showDataToggles={true}
              defaultToggleOption={TOGGLE_OPTIONS.DOWNLOAD_FILE}
              clientContextVariables={useView.clientContext?.clientContextVariables || []}
            />
          )}
        </div>
      );
    }

    return response;
  }
}

export interface InfoPaneButtonsProps {
  parentView?: View;
  vifs: Vif[];
  view?: View;
}

export function mapStateToProps(state: ReturnType<typeof reducer>) {
  return {
    parentView: state?.parentView,
    view: state?.view,
  };
}

// @ts-ignore Until the reducer is migrated to typescript and we have a type definition for State, this is going to complain
export default connect(mapStateToProps)(InfoPaneButtons);
